import React from 'react';
import { Button, DatePicker, Form, Input, Modal, Table } from 'antd';
import dayjs from 'dayjs';

/** 构建公告管理标签页。 */
export function buildAnnouncementsTab(context) {
  const {
    shouldShowPage,
    setEditingAnn,
    announcementForm,
    setAnnModalVisible,
    announcements,
    handleEditAnn,
    handleDeleteAnn,
    annModalVisible,
    editingAnn,
    handleSaveAnn
  } = context;

  if (!shouldShowPage('公告管理')) return null;

  const formatDateTime = (text) => {
    if (!text) return '-';
    // 已是后端 TO_CHAR 的本地字符串时直接展示
    if (typeof text === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(text)) {
      return text.length >= 16 ? text.slice(0, 16) : text;
    }
    const d = dayjs(text);
    return d.isValid() ? d.format('YYYY-MM-DD HH:mm') : '-';
  };

  return {
    key: 'announcements',
    label: '公告管理',
    children: (
      <div>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={() => { setEditingAnn(null); announcementForm.resetFields(); setAnnModalVisible(true); }}>添加公告</Button>
        </div>
        <Table
          rowKey="id"
          dataSource={announcements}
          scroll={{ x: 960 }}
          columns={[
            { title: 'ID', dataIndex: 'id', key: 'id', width: 70 },
            { title: '标题', dataIndex: 'title', key: 'title', width: 140 },
            { title: '内容', dataIndex: 'content', key: 'content', ellipsis: true },
            {
              title: '生效开始时间',
              dataIndex: 'start_time',
              key: 'start_time',
              width: 160,
              render: formatDateTime
            },
            {
              title: '生效结束时间',
              dataIndex: 'end_time',
              key: 'end_time',
              width: 160,
              render: formatDateTime
            },
            {
              title: '创建时间',
              dataIndex: 'created_at',
              key: 'created_at',
              width: 160,
              render: formatDateTime
            },
            { title: '操作', key: 'action', width: 140, fixed: 'right', render: (_, record) => (
              <span>
                <Button type="link" onClick={() => handleEditAnn(record)}>编辑</Button>
                <Button type="link" danger onClick={() => handleDeleteAnn(record.id)}>删除</Button>
              </span>
            ) }
          ]}
        />
        <Modal
          open={annModalVisible}
          onCancel={() => setAnnModalVisible(false)}
          onOk={() => announcementForm.submit()}
          title={editingAnn ? '编辑公告' : '添加公告'}
          width={600}
        >
          <Form form={announcementForm} onFinish={handleSaveAnn} initialValues={editingAnn ? {
            title: editingAnn.title || '',
            content: editingAnn.content || '',
            start_time: editingAnn.start_time ? dayjs(editingAnn.start_time) : null,
            end_time: editingAnn.end_time ? dayjs(editingAnn.end_time) : null
          } : {}}>
            <Form.Item name="title" label="标题" rules={[{ required: true, message: '请输入公告标题' }]}>
              <Input placeholder="请输入公告标题" />
            </Form.Item>
            <Form.Item name="content" label="内容" rules={[{ required: true, message: '请输入公告内容' }]}>
              <Input.TextArea rows={4} placeholder="请输入公告内容" />
            </Form.Item>
            <Form.Item
              name="start_time"
              label="生效开始时间"
              rules={[{ required: true, message: '请选择生效开始时间' }]}
              extra="公告仅在此时间之后对用户展示"
            >
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                placeholder="选择生效开始时间"
                style={{ width: '100%' }}
                allowClear={true}
                showToday={true}
              />
            </Form.Item>
            <Form.Item
              name="end_time"
              label="生效结束时间"
              rules={[
                { required: true, message: '请选择生效结束时间' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const start = getFieldValue('start_time');
                    if (!value || !start || !value.isBefore(start)) return Promise.resolve();
                    return Promise.reject(new Error('结束时间不能早于开始时间'));
                  }
                })
              ]}
              extra="到期后公告自动不再展示"
            >
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                placeholder="选择生效结束时间"
                style={{ width: '100%' }}
                allowClear={true}
                showToday={true}
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  };
}
